<script setup>
import { computed } from 'vue';
import { useState, defineProps, useGetters } from 'vuex-composition-helpers';

defineProps(['gateway']);

const { orgId } = useState(['orgId']);
const { isMultiEntity, additionalDisclaimer } = useState('publicOrgSettings', ['isMultiEntity', 'additionalDisclaimer']);
const { isOnlyDafEnabled } = useGetters('campaign', ['isOnlyDafEnabled']);

const isTA = computed(() => {
  return orgId.value === 'fcd56800-a5a0-11f0-906d-af3999bfd9c9';
});
</script>

<template>
  <div
    v-if="(isMultiEntity || additionalDisclaimer) && !isOnlyDafEnabled"
    class="flex items-start my-2 rounded-lg p-3 text-xs gap-2"
    style="background: rgba(9, 27, 39, 0.05); color: var(--black-01)"
  >
    <app-icon name="info" type="svg" width="12" height="12" class="mt-0.5 text-black fill-current" />
    <div>
      <p v-if="isMultiEntity">
        <template v-if="isTA">Your donation is 100% Tzedaka, Ma'aser and tax deductible. 12 month minimum on monthly donations.</template>

        Your donation will be made to {{ gateway.entityName }} Tax ID {{ gateway.entityTaxId }}. You'll receive a tax-deductible receipt recognized in
        {{ gateway.country === 'USA' ? 'the' : '' }} {{ gateway.country }}.
      </p>
      <p v-if="additionalDisclaimer" class="whitespace-pre-line" :class="{ 'mt-2': isMultiEntity }">{{ additionalDisclaimer }}</p>
    </div>
  </div>
</template>
